// extracted by mini-css-extract-plugin
export default {"header":"main_header__OrpE-","wrapper":"main_wrapper__Caau4","container":"main_container__1+boo"};